import {
    CHART_CONDITION_TREND_KPI_TYPE,
    CONDITION_TREND_KPI_OPERATIONAL_EVENTS,
    CONDITION_TREND_KPI_OTHER_EVENTS,
    CONDITION_TREND_KPI_PROTECTION_EVENTS
} from '../../components/PowertrainAssetDetails/DetailedInformation/ConditionInsights/CommonCharts/DriveStatus/constants';
import { DEFAULT_PRECISION } from 'helpers/constants';
import { baseToCustomUOM, getMeasurementUnits } from 'helpers/unitHelper';
import { forEach } from 'lodash';

const isFromConditionTrendsHourly = (kpi) => {
    return kpi?.isHourlyData && kpi?.conditionTrendsHourly;
};

const getKpiConditionTrends = (kpi) => {
    if (kpi?.isHourlyData) {
        return kpi?.conditionTrendsHourly ?? [];
    }

    return kpi?.conditionTrends ?? [];
};

export const handleKpisUnitConversion = (response) => {
    const userMeasurementUnitGroups = getMeasurementUnits();

    forEach(response.KPIs, (kpi) => {
        const precision = kpi?.precision ?? kpi?.timeseriesPrecision ?? DEFAULT_PRECISION;
        const isConditionTrendHourly = isFromConditionTrendsHourly(kpi);
        const conditionTrendsData = (getKpiConditionTrends(kpi) ?? []).map((trend) => ({
            ...trend,
            isHourlyData: !!kpi?.isHourlyData,
            isFromConditionTrendsHourly: isConditionTrendHourly,
        }));

        kpi.conditionTrends = conditionTrendsData;
        // Unit conversion for trend data
        forEach(kpi.trend, (prop) => {
            const convertObj = baseToCustomUOM.convertAndFormatWithGroups(kpi.unitGroupId, prop.value, userMeasurementUnitGroups);
            prop.value = convertObj?.measurementValue % 1 === 0 ? convertObj?.measurementValue : Number.parseFloat(convertObj?.measurementValue?.toFixed(precision));
            if (prop.min !== undefined) {
                const convertMinObj = baseToCustomUOM.convertAndFormatWithGroups(kpi.unitGroupId, prop.min, userMeasurementUnitGroups);
                prop.min = convertMinObj?.measurementValue % 1 === 0 ? convertMinObj?.measurementValue : Number.parseFloat(convertMinObj?.measurementValue?.toFixed(precision));
            }
            if (prop.max !== undefined) {
                const convertMaxObj = baseToCustomUOM.convertAndFormatWithGroups(kpi.unitGroupId, prop.max, userMeasurementUnitGroups);
                prop.max = convertMaxObj?.measurementValue % 1 === 0 ? convertMaxObj?.measurementValue : Number.parseFloat(convertMaxObj?.measurementValue?.toFixed(precision));
            }
        });
        // Unit conversion for condition trend Warning and Error KPI's
        forEach(kpi.conditionTrends, (trend) => {
            if (
                ![CHART_CONDITION_TREND_KPI_TYPE, CONDITION_TREND_KPI_PROTECTION_EVENTS,
                    CONDITION_TREND_KPI_OPERATIONAL_EVENTS, CONDITION_TREND_KPI_OTHER_EVENTS].includes(trend.type)
            ) {
                forEach(trend.values, (prop) => {
                    if (!isNaN(prop.value)) {
                        const convertObj = baseToCustomUOM.convertAndFormatWithGroups(kpi.unitGroupId, prop.value, userMeasurementUnitGroups);
                        prop.value = convertObj?.measurementValue % 1 === 0 ? convertObj?.measurementValue : Number.parseFloat(convertObj?.measurementValue?.toFixed(precision));
                    }
                });
            }
        });
        // Unit conversion for condition events (arrow icon)
        forEach(kpi.conditionEvents, (prop) => {
            const convertObj = baseToCustomUOM.convertAndFormatWithGroups(kpi.unitGroupId, prop.trendValue, userMeasurementUnitGroups);
            prop.trendValue = convertObj?.measurementValue % 1 === 0 ? convertObj?.measurementValue : Number.parseFloat(convertObj?.measurementValue?.toFixed(precision));
            if (prop.detectedTrend) {
                const convertY0 = baseToCustomUOM.convertAndFormatWithGroups(kpi.unitGroupId, prop.detectedTrend.y0, userMeasurementUnitGroups);
                const convertY1 = baseToCustomUOM.convertAndFormatWithGroups(kpi.unitGroupId, prop.detectedTrend.y1, userMeasurementUnitGroups);
                prop.detectedTrend = {
                    ...prop.detectedTrend,
                    y0: convertY0?.measurementValue % 1 === 0 ? convertY0?.measurementValue : Number.parseFloat(convertY0?.measurementValue?.toFixed(precision)),
                    y1: convertY1?.measurementValue % 1 === 0 ? convertY1?.measurementValue : Number.parseFloat(convertY1?.measurementValue?.toFixed(precision)),
                };
            }
        });
    });
    return response;
};
